import { useAccount, useCapabilities } from 'wagmi';

/**
 * Detects if the connected wallet is an Account Abstraction wallet (ERC-4337)
 * that may have limited cross-chain support.
 *
 * This distinguishes between:
 * - ERC-4337 wallets (Coinbase Smart Wallet): Has paymasterService capability
 * - EIP-7702 wallets (MetaMask Smart Wallet): Only has atomic capability
 *
 * EIP-7702 wallets should NOT be blocked as they use existing EOAs and work across all chains.
 */
export const useIsAccountAbstractionWallet = ({ chainId }: { chainId: number | undefined }) => {
  const { isConnected } = useAccount();
  const capabilities = useCapabilities();

  if (!isConnected || !chainId || !capabilities.data?.[chainId]) return false;

  const chainCapabilities = capabilities.data[chainId];

  // ERC-4337 wallets expose paymasterService capability (ERC-7677)
  // EIP-7702 wallets only expose atomic batching capability
  // Check for paymasterService to identify true AA wallets
  const hasPaymasterService = 'paymasterService' in chainCapabilities;

  return hasPaymasterService;
};
